// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopTabs_wrapper__3TrD7"};